import * as React from "react";
// Controls
import { Dialog, DialogType } from "@fluentui/react";
// Styles
import { OneDrivePicker } from "./OneDrivePicker";
import { getDialogStyleFunction } from "../../../utilities/BaseDialog.styles";
/**
 * OneDrive picker dialog component
 */ export function OneDrivePickerDialog({ dialogContentClassName, dialogContentStyles, dialogClassName, dialogContainerClassName, modalStyles, layerProps, focusTrapZoneProps, styles, oneDrivePickerProps }) {
    return /*#__PURE__*/ React.createElement(Dialog, {
        hidden: false,
        dialogContentProps: {
            className: dialogContentClassName,
            type: DialogType.close,
            styles: dialogContentStyles
        },
        modalProps: {
            className: dialogClassName,
            containerClassName: dialogContainerClassName,
            isBlocking: false,
            styles: modalStyles,
            layerProps: layerProps,
            focusTrapZoneProps: focusTrapZoneProps
        },
        styles: getDialogStyleFunction(styles),
        onDismiss: oneDrivePickerProps.onDismiss
    }, /*#__PURE__*/ React.createElement(OneDrivePicker, oneDrivePickerProps));
}
